// @flow

export default {
  "work-income": {
    label: "Work Income",
    helpText:
      "The after-tax money you took home from your job(s) during this month."
  },
  "401k-match": {
    label: "401(k) Match",
    helpText:
      "Some workplaces match contributions you make to your retirement accounts, or even make contributions directly. If your workplace has a program like this, enter the amount they contributed for the month here."
  },
  "other-income": {
    label: "Other Income",
    helpText:
      "All other income from this month. This can include cash gifts, side hustle income, an inheritance, etc. Use after-tax values."
  },

  "other-retirement": {
    label: "Other Retirement Contributions",
    helpText:
      "Enter the amount of money that you contributed to retirement accounts (401(k), 403(b), 457, etc.), not counting any employer match."
  },
  "taxable-savings": {
    label: "Taxable Account",
    helpText:
      "If you've contributed any money to a brokerage, bought a CD at the bank, or contributed any other money to an account intended for retirement, enter it here. Count new contributions only, not dividends or growth. (And if you've withdrawn money from an account intended for retirement, enter a negative number.)"
  },
  "home-equity": {
    label: "Home Equity",
    helpText:
      "If you're paying for a home, enter the amount of principal (not interest) you paid on your mortgage here."
  },
  debt: {
    label: "Paying Debt",
    helpText:
      "If you're paying off a debt besides your mortgage, like a student or auto loan or credit card debt, enter the amount of principal (not interest) you paid off this month. If you took on new debt, you can enter a negative number."
  },
  "net-worth": {
    label: "Total Net Worth",
    helpText:
      "Enter your net worth as of the end of this month. This is optional, but allows us to more accurately calculate how long until you're financially independent!"
  }
};



// WEBPACK FOOTER //
// ./src/calc/inputText.js